import { combineReducers, createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';

import { reducer as reduxFormReducer } from 'redux-form';
import {
  themeReducer,
  rtlReducer,
  cryptoTableReducer,
  customizerReducer,

  sidebarReducer,
  authReducer,
  roundBordersReducer,
  blocksShadowsReducer,
  loadingActionReducer,
  orderPreferencesReducer,
} from 'src/redux/reducers/index';
import appConfigReducer from 'src/redux/reducers/appConfigReducer';
import todoReducer from '../Todo/redux/reducer';

import roleReducer from 'src/redux/reducers/roleReducer';

// console.log('orderPreferencesReducer imported in store:', orderPreferencesReducer);

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  rtl: rtlReducer,
  roundBorders: roundBordersReducer,
  blocksShadows: blocksShadowsReducer,
  appConfig: appConfigReducer,
  cryptoTable: cryptoTableReducer,
  customizer: customizerReducer,

  sidebar: sidebarReducer,
  user: authReducer,
  todo: todoReducer,
  loader: loadingActionReducer,
  roleReducer: roleReducer,
  orderPreferences: orderPreferencesReducer
});
const store = createStore(reducer, applyMiddleware(thunk));

export default store;
